import { client } from './Graph';

export const forceLogout = async () => {
  if (localStorage.getItem('accessToken')) {
    localStorage.removeItem('accessToken');
    await client.clearStore();
    window.location.reload();
  }
};
